export const RECEITAS = 'RECEITAS';
export const RECEITAS_START = 'RECEITAS_START';
export const RECEITAS_SUCCESS = 'RECEITAS_SUCCESS';
export const RECEITAS_ERROR = 'RECEITAS_ERROR';

export const EXPAND_RECEITA = 'EXPAND_RECEITA';
export const COLLAPSE_RECEITA = 'COLLAPSE_RECEITA';
